export const SortSet = ( status: string ) => {
  const sortWrap: HTMLElement = document.querySelector(".p-talk__room__list")!;
  const Reset = () => {
    sortWrap.classList.remove("p-talk__room__list--done");
    sortWrap.classList.remove("p-talk__room__list--required");
    sortWrap.classList.remove("p-talk__room__list--unread");
  }
  if (status !== "") {
    sortWrap.style.opacity = "0";
    Reset();
    setTimeout(()=>{
      sortWrap.classList.add(`p-talk__room__list--${status}`);
      sortWrap.style.opacity = "1";
    },100)
  } else {
    Reset();
  }
}

export const CheckNone = ( status: string ) => {
  const roomNone:HTMLElement = document.querySelector(".c-room__none")!;
  if (roomNone) {
    let roomLists: NodeListOf<HTMLElement>;
    if (status == "") {
      roomLists = document.querySelectorAll(".c-room__list");
    } else {
      roomLists = document.querySelectorAll(`.c-room__list[data-status="${status}"]`)!;
    }
    let roomListsLength: number = 0;
    roomListsLength += Number(roomLists.length);
    if (roomListsLength > 0) {
      roomNone.classList.add("c-room__none--hidden");
    } else {
      roomNone.classList.remove("c-room__none--hidden");
    }
  }
}
